import { css, styled } from '@zoopla-eng/zds-components/themes';
import { Box } from '@zoopla-eng/zds-components/box';

const mobileShadow =
    '0px 0px 12px -12px rgba(50, 39, 68, 0.08), 0px 0px 1px -1px rgba(50, 39, 68, 0.32), 0px 8px 16px -8px rgba(50, 39, 68, 0.24)';

export const LocationSearchInputWrapper = styled('div', {
    margin: '$S100 0',
    input: {
        '@M100': {
            borderColor: 'transparent'
        }
    },
    '@S100': {
        pb: '$S200'
    },
    '@M100': {
        pb: '0'
    },
    label: {
        position: 'absolute',
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    },
    div: {
        rowGap: '0px'
    }
});

export const Headline = styled('p', {
    fontFamily: 'ZooplaDisplay',
    fontGroup: 'kettle',
    fontWeight: '$400',
    fontSize: '$M300',
    color: '$purpleDark',
    padding: '$S400 $S400 0 $S400',
    marginBottom: '$S200',

    // 768 +
    '@M100': {
        fontGroup: 'teapot',
        color: '$textContrast',
        marginBottom: '20px',
        padding: '0',
        textShadow: '$100',
        alignSelf: 'center'
    }
});

export const SubHeader = styled('h1', {
    fontWeight: '$200',
    fontGroup: 'whisk',
    color: '$purpleDark',
    padding: '0 $S400 $S200 $S400',
    '@M100': {
        color: '$textContrast',
        fontWeight: '$400',
        fontSize: '$S500',
        alignSelf: 'center',
        marginBottom: '20px',
        textShadow: '$100',
        paddingBottom: '0'
    },
    variants: {
        isLoggedIn: {
            true: {
                fontWeight: '$400',
                fontGroup: 'mug',
                textAlign: 'center',
                '@M100': {
                    color: '$textTitle'
                }
            }
        }
    }
});

export const TabWrapper = styled(Box, {
    backgroundColor: '$graphicBackgroundDefault',
    height: 'auto',
    borderRadius: '$500',
    boxShadow: `${mobileShadow}`,
    variants: {
        isLoggedIn: {
            true: {
                boxShadow: 'inherit',
                '@M100': {
                    boxShadow: `${mobileShadow}`
                }
            }
        }
    },
    '@M100': {
        boxShadow: '$100'
    }
});

export const StyledBold = styled('b', {
    color: '$brandSecondary'
});

export const HeroWrapper = styled('div', {
    position: 'absolute',
    left: '0px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    height: '46.25vw',
    padding: `calc(46.25vw - $S400) 0 0 0`,
    '@M100': {
        padding: '9.5vw 0px',
        height: 'calc(20vw + 220px)'
    },
    variants: {
        isLoggedIn: {
            true: {
                position: 'relative',
                height: 'auto',
                padding: 0,
                '@M100': {
                    py: '$S400'
                }
            }
        }
    }
});

export const HeroContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    bg: 'white',
    borderRadius: '$500 $500 0 0',
    '@S200': {
        borderRadius: '$500',
        width: '720px',
        background: 'none'
    },
    variants: {
        isLoggedIn: {
            true: {
                py: '$S400',
                borderRadius: '0'
            }
        }
    }
});

export const heroImageStyles = css({
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: '-1'
});

export const HeroSpacer = styled('div', {
    paddingBottom: `calc(453px + 21.40vw)`,
    '@S200': {
        paddingBottom: 'calc(311px + 46.54vw)'
    },
    '@M100': {
        paddingBottom: 'calc(264px + 20.39vw)'
    },
    '@L100': {
        paddingBottom: 'calc(269px + 19.95vw)'
    },
    variants: {
        isLoggedIn: {
            true: {
                position: 'relative',
                height: 'auto',
                backgroundImage: '',
                paddingBottom: 'inherit'
            }
        }
    }
});
